import React, { Component } from "react";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { Stack, CommandBar, ContextualMenuItemType, Icon, FontSizes } from "office-ui-fabric-react";
import "../ConversationSafe.css";
import { MyContext } from "../../../context";
import DownloadDialog from "../../DetailView/DetailPivot/PivotElements/Transscript/DownloadDialog";

export class ConversationSafeAccordionHeader extends Component {
    static contextType = MyContext;

    constructor(props) {
        super(props);
        this.state = { folder: this.props.folder };
    }

    folderName = (name, conversationSize) => {
        var result = name.length > 25 ? `${name.substring(0, 25)} ...` : name;
        result += ` (${conversationSize})`;
        return result;
    };

    folderSupervisors = (folder) => {
        if (
            this.props.userRules.ruleAccess.userSafe === "Full" ||
            (folder.userId === this.props.userRules.userId && this.props.userRules.ruleAccess.ownFolder.shareFolders)
        ) {
            if (!folder.supervisors.length) return "-";
            var supervisors = folder.supervisors
                .map((supervisor) => {
                    return supervisor.mail ? supervisor.mail : supervisor.name;
                })
                .join(", ");
            return supervisors.length > 70 ? supervisors.substring(0, 67) + "..." : supervisors;
        } else {
            return "";
        }
    };

    menuIsNeeded = () => {
        return this.props.folder.id !== null && this.props.isMyQueue !== true;
    };

    getAttention = () => {
        if (!this.state.folder.supervisors.length) return "";
        let attention = this.state.folder.attentionRequired !== "";
        return attention ? <Icon style={{ padding: "0px", fontSize: FontSizes.icon, color: "red" }} iconName="Important" title="Attention!" /> : "";
    };

    getStatus = (status) => {
        const lowercaseStatus = status ? status.toLowerCase() : "";
        return this.context.getTranslation("compliance", lowercaseStatus);
    };

    render() {
        const menuItems = [
            {
                key: "Actions",
                itemType: ContextualMenuItemType.Header,
                text: this.context.getTranslation("dashboard", "widgetMenuActions"),
                itemProps: {
                    lang: "en-us",
                },
            },
            {
                key: "Edit",
                iconProps: {
                    iconName: "Edit",
                },
                text: this.context.getTranslation("conversationSafe", "folderSettings"),
                disabled: (this.props.folder.isCaseManagement && !this.props.userRules.ruleAccess.isUsedForCaseManagement) || (!this.props.rights.editRight && this.props.userRules.ruleAccess.userSafe != "Full"),
                onClick: () => {
                    this.props.openPanel(this.props.folder.id);
                },
            },
            {
                key: "Delete",
                hidden: !this.props.rights.userIsCreator && this.props.userRules.ruleAccess.userSafe !== "Full",
                iconProps: {
                    iconName: "Delete",
                },
                text: this.context.getTranslation("conversationSafe", "deleteFolder"),
                disabled: (this.props.folder.isCaseManagement && !this.props.userRules.ruleAccess.isUsedForCaseManagement) || (!this.props.rights.deleteFolder && this.props.userRules.ruleAccess.userSafe != "Full"),
                onClick: () => {
                    this.props.openDeleteFolderDialog(this.props.folder.id);
                },
            },
            {
                key: "Export",
                onRender: () => (
                    <DownloadDialog
                        client={this.props.propsForExportDialog.client}
                        authorization={this.props.propsForExportDialog.auth}
                        export={this.state.folder.conversations.map((e) => e.conversationId)}
                        folderId={this.props.folder.id}
                        folderName={this.props.folder.name}
                        renderFromCompliance={true}
                        disableForMenuItemsCompliance={(this.props.folder.isCaseManagement && !this.props.userRules.ruleAccess.isUsedForCaseManagement) || (!this.props.rights.exportFolder && this.props.userRules.ruleAccess.userSafe != "Full")}
                    />
                ),
            },
        ];
        return (
            <div className="flex" onClick={(e) => e.stopPropagation()}>
                {this.props.width > 550 && (
                    <div className="accordionHeaderColumns">
                        {this.props.isMyQueue !== true && <Icon
                            style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }}
                            iconName={this.props.folder.isCaseManagement ? "ReportWarning" : "FabricFolder"}
                            title={this.props.folder.isCaseManagement ?
                                this.context.getTranslation("dashboard", "case") :
                                this.context.getTranslation("configuration", "folder")}
                        />}
                        <div style={{ fontSize: "16px", fontWeight: "600" }}>
                            {this.folderName(this.state.folder.name, this.state.folder.conversations.length)}
                        </div>
                        <div>
                            {this.props.folder.caseManagementDetails?.legalHold && (
                                <>
                                    <Icon
                                        style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }}
                                        iconName={"LockSolid"}
                                        title={this.context.getTranslation("compliance", "legalHold")} />
                                </>
                            )}
                        </div>
                        <div>{this.getStatus(this.props.folder.caseManagementDetails?.caseStatus)}</div>
                        <div>{this.state.folder.ownerName}</div>
                        {this.props.width > 850 && <div>{this.folderSupervisors(this.state.folder)}</div>}
                        <div style={{ maxWidth: "30px" }}>{this.getAttention()}</div>
                    </div>
                )}
                {this.props.width <= 550 && (
                    <div>
                        <TooltipHost
                            content={
                                this.context.getTranslation("compliance", "creator") +
                                ": " +
                                this.state.folder.ownerName +
                                " / " +
                                this.context.getTranslation("compliance", "detailPolicyUsers") +
                                ": " +
                                this.folderSupervisors(this.state.folder)
                            }
                            styles={{ root: { display: "inline-block" } }}
                        >
                            <div className="flex">
                                <Icon
                                    style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }}
                                    iconName={this.props.folder.isCaseManagement ? "ReportWarning" : "FabricFolder"}
                                    title={this.context.getTranslation("configuration", this.props.folder.isCaseManagement ? "caseManagement" : "conversationSafe")}
                                />
                                <div style={{ fontSize: "16px", fontWeight: "600" }}>
                                    {this.folderName(this.state.folder.name, this.state.folder.conversations.length)}
                                </div>
                                {this.props.folder.caseManagementDetails?.legalHold && (
                                    <>
                                        <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }} iconName={"LockSolid"} />
                                    </>
                                )}
                                <div style={{ maxWidth: "30px" }}>{this.getAttention()}</div>
                            </div>
                        </TooltipHost>
                    </div>
                )}
                {this.menuIsNeeded() && (
                    <Stack horizontal>
                        <Stack.Item>
                            <CommandBar
                                className="commandBar"
                                overflowItems={menuItems}
                                styles={{
                                    root: {
                                        paddingRight: "0px",
                                    },
                                }}
                            />
                        </Stack.Item>
                    </Stack>
                )}
            </div>
        );
    }
}
